import { render, staticRenderFns } from "./SubscriptionPlans.vue?vue&type=template&id=536d2e5f&"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPlans.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports